import React from 'react';
import { Navbar } from 'react-bootstrap';
import '../../styles/NavBar.scss';

export const NavBar = () => {
	return (
		<Navbar bg='light' variant='dark' className='justify-content-between navbar-height'>
			<Navbar.Brand href='/'>
				<div className='navbar-logo'></div>
			</Navbar.Brand>
			<h3 className='navbar-text'>Celebremos San Nicolás</h3>
		</Navbar>
	);
};
